import { render, staticRenderFns } from "./profile-admin.vue?vue&type=template&id=ee4ecd72&scoped=true"
import script from "./profile-admin.vue?vue&type=script&lang=js"
export * from "./profile-admin.vue?vue&type=script&lang=js"
import style0 from "./profile-admin.vue?vue&type=style&index=0&id=ee4ecd72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4ecd72",
  null
  
)

export default component.exports